import React from 'react'

export default function Video({src}) {
    return (
        <div>
            <video style={{width: '100%'}} src={src} controls>
            </video>
        </div>
    )
}
